export const GET_GIVEAWAY = "GET_GIVEAWAY"